import { render } from "./QwButtonMain.vue?vue&type=template&id=d84f8278"
import script from "./QwButtonMain.vue?vue&type=script&lang=js"
export * from "./QwButtonMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__